function Domains() {
  return (
    <section className="section domains">
      <div className="container-fluid">

        {/* Section Title */}
        <div className="mb-5">
          <h1 className="section-title">Domains of Focus</h1>
        </div>

        {/* Domains Grid */}
        <div className="row">

          {/* Domain 1 */}
          <div className="col-md-6 mb-5">
            <h3>Artificial Intelligence & Data Science</h3>
            <p>
              My work in AI focuses on building and adapting intelligent models
              to understand language, vision, and biological data. I explore how
              modern architectures such as LLMs and VLMs can be extended beyond
              text to solve complex real-world problems.
            </p>
          </div>

          {/* Domain 2 */}
          <div className="col-md-6 mb-5">
            <h3>Software Engineering & Systems Programming</h3>
            <p>
              I build software with a strong emphasis on system design, memory
              management, and correctness. This includes low-level programming,
              concurrent systems, and full-stack applications designed for
              scalability and robustness.
            </p>
          </div>

          {/* Domain 3 */}
          <div className="col-md-6 mb-5">
            <h3>Robotics, IoT & Autonomous Systems</h3>
            <p>
              I work at the intersection of hardware and software, designing
              autonomous and connected systems that operate in real environments.
              My focus includes robotics control, embedded systems, and
              perception-driven autonomy.
            </p>
          </div>

          {/* Domain 4 */}
          <div className="col-md-6 mb-5">
            <h3>Electrical, Communication & Computer Engineering</h3>
            <p>
              My background in computer engineering spans signal processing,
              communication systems, and computer architecture. I am interested
              in how physical-layer constraints and architectural decisions shape
              system-level performance.
            </p>
          </div>

          {/* Domain 5 */}
          <div className="col-md-6 mb-5">
            <h3>Design, Research & Sustainability</h3>
            <p>
              Alongside technical work, I engage in design-driven and
              interdisciplinary research, exploring ergonomics, social systems,
              and environmental sustainability to understand the broader impact
              of engineering decisions.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Domains;
